import Vue from 'vue';
import Router from 'vue-router';
import { isMobile } from 'mobile-device-detect';
import config from '../../static/config/app.js';

Vue.use(Router);

var loggedRoute = "Dashboard";
var notLoggedRoute = "Login";
var routesArray = [];
// var routesArray = config.rotas;

const fetchMenuItens = async () => {
    console.log("fetchMenuItens()")
    const response = await fetch(config.url + 'api/itens.php?nome=menu-itens'); 
    const data = await response.json();
    return data["result"]["objeto"] ? data["result"]["objeto"] : config.menuItens;
};

const fetchRoutes = async () => {
    console.log("fetchRoutes()")
    const response = await fetch(config.url + 'api/itens.php?nome=rotas'); 
    const data = await response.json();
    return data["result"]["objeto"] ? data["result"]["objeto"] : config.menuItens;
};

const initializeRoutes = (menuItens) => {
    console.log("ITENS DO MENU>", menuItens['contratante'])

    routesArray.forEach(function (item, i) {
        if (item.meta.auth) {
            let level = item.meta.level ? item.meta.level : [];
            Object.keys(menuItens).forEach(function (item2) {
                menuItens[item2].forEach(function (item3) {
                    if (item3.rota == item.name) {
                        level.push(item2);
                    }
                })
            })
            routesArray[i].meta.level = level;
        }
    })

    console.log("Rotas:", routesArray)

    const checkLogin = (to, from, next) => {
        console.log("checkLogin()", to, from)
        if (!window.localStorage.getItem("_usuario")) {
            if (to.name === loggedRoute) {
                next({ name: notLoggedRoute });
                return;
            }
            if (to.meta.auth === false || typeof to.meta.auth === "undefined") {
                next();
                return;
            }
        } else {
            try {
                let usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                window.__usuario = usuario;
                if (usuario.cod) {
                    if (to.meta.auth === false) {
                        routerInstance.push({
                            name: loggedRoute,
                            params: {
                                "reload": 1
                            }
                        }).catch(() => { });
                        if (routerInstance.currentRoute.params.reload === 1) {
                            window.location.reload();
                        }
                        return;
                    }

                    if (to.meta.auth && to.meta.level) {
                        if (to.meta.level.indexOf(usuario.tipo) === -1 && to.query.embedded != '1') {
                            if (from.name == "Menu") {
                                const submenus = menuItens[usuario.tipo].filter(item => item.tipo == "submenu");
                                
                                submenus.forEach(item => {
                                    if (item.itens.some(subrota => subrota.rota == to.Name)) {
                                        next();
                                        return;
                                    }
                                });
                            } else {
                                routerInstance.push({
                                    name: loggedRoute
                                }).catch(() => { });
                            }
                        }
                    }

                    next();
                    return;
                }
            } catch (err) {
                // error handling
            }
        }

        routerInstance.push({
            name: notLoggedRoute
        }).catch(() => { });
    };

    // Mapeamento das rotas para incluir a importação dinâmica dos componentes
    let routes = routesArray.map(route => ({
        ...route,
        beforeEnter: checkLogin,
        component: () => import("../" + route.component)
    }));

    routes.push({
        "path": "*",
        "redirect": "/"
    });

    const routerInstance = new Router({
        routes
    });

    const scrollPositions = Object.create(null);

    routerInstance.beforeEach((to, from, next) => {
        let element = document.querySelector(".dashboard-content-inner");
        if (element) {
            scrollPositions[from.name] = element.scrollTop;
        }

        next();
    });

    window.addEventListener('popstate', () => {
        setTimeout(function () {
            let currentRouteName = routerInstance.history.current.name;
            let element = document.querySelector(".dashboard-content-inner");
            if (element && scrollPositions[currentRouteName]) {
                element.scrollTop = scrollPositions[currentRouteName];
                scrollPositions[currentRouteName] = null;
            }
        }, 100);
    });

    return routerInstance;
};

export const initializeRouter = async () => {
    console.log("initializeRouter()")
    try {
        const menuItens = await fetchMenuItens();
        routesArray = await fetchRoutes();
        const routerInstance = initializeRoutes(menuItens);
        return routerInstance;
    } catch (error) {
        console.error('Erro ao buscar os itens do menu:', error);
    }
};


// WEBPACK FOOTER //
// ./src/router/index.js